// extracted by mini-css-extract-plugin
export default {"content":"mE1uisUSc_RKUkUsHHj___content___","title":"Y4B7uRjU3NOCF7tPrmcC__title___"};